
import { useState } from "react"
import { spartansOption, spartansUpgrade } from "../../../../data/upgrade/spartans"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const SpartansUpgrade = (props) => {
    const selectList = spartansOption
    const lvl = Array.from({ length: 20 }, (_, index) => ({ id: index + 1, name: `Level ${index + 1}` }));

    const [selectValue, setSelectValue] = useState({name:"", lvl:"1"})
    const handleSelectName = event => {
        setSelectValue(prevState => ({ name: event.target.value, lvl: prevState.lvl }));
    } 
    const handleSelectLvl = event => {
        setSelectValue(prevState => ({ ...prevState, lvl: event.target.value }));
    }
    
      
    function vypis(){
        const selectedSpartansUpgrade = spartansUpgrade[selectValue.name - 1][selectValue.lvl-1]
        const item =[{id:1,
                      name: spartansOption[selectValue.name - 1].name + " " + selectedSpartansUpgrade.level ,
                      wood: selectedSpartansUpgrade.wood,
                      clay: selectedSpartansUpgrade.clay,
                      iron: selectedSpartansUpgrade.iron,
                      crop: selectedSpartansUpgrade.crop,
                      all: selectedSpartansUpgrade.all}]
        props.addItem(item[0])
    }
    

    
    return(
        <div>
            <ListSelect label="...choose a trop" selectList={selectList} handleSelectValue={handleSelectName} />
            <ListSelect label="...choose a level" selectList={lvl} handleSelectValue={handleSelectLvl}/>
            {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}

        </div>
    )
}
export default SpartansUpgrade